import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { Store } from "@ngrx/store";
import { RouteAction } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { filter, map, take } from "rxjs/operators";

import { CoreState } from "../../state";
import { AUTH_ROUTE } from "../auth.const";
import { AuthenticationStatus } from "../auth.model";
import { AuthSelector } from "../auth.selector";

@Injectable({
	providedIn: "root",
})
export class AuthSecureGuard implements CanActivate {
	constructor(private store: Store<CoreState>) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.store.select(AuthSelector.getAuthenticationStatus).pipe(
			filter((status) => status !== AuthenticationStatus.Pending),
			take(1),
			map((status) => {
				if (status === AuthenticationStatus.Authenticated) {
					return true;
				}
				this.store.dispatch(
					RouteAction.navigate(AUTH_ROUTE.login, undefined, { queryParams: { returnUrl: state.url } })
				);
				return false;
			})
		);
	}
}
